import React from "react";
import { useLocation } from "react-router-dom";
import { getWindowDimensions } from "./../utils";

const WhatsAppButton = () => {
  const phoneNumber = "918527894154";
  const message = encodeURIComponent(
    "Hi! I have a query about HueHoppers. Can you help me?",
  );
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  const location = useLocation();
  const isProductPage = location.pathname.startsWith("/products/");
  const isMobile = getWindowDimensions().width < 1368;

  // ── PDP pe sticky bar hai toh aur upar rakho ──────────────
  const bottomPosition = isProductPage && isMobile ? 194 : 114;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noreferrer"
      style={{
        position: "fixed",
        bottom: bottomPosition,
        right: 24,
        zIndex: 1050,
        backgroundColor: "#25D366",
        borderRadius: "50%",
        width: 56,
        height: 56,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        transition: "transform 0.2s ease, bottom 0.2s ease",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1.0)")}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="30"
        height="30"
        fill="#fff"
      >
        <path d="M16 0C7.163 0 0 7.163 0 16c0 2.822.736 5.463 2.02 7.76L0 32l8.528-2.007A15.93 15.93 0 0016 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 01-6.756-1.844l-.484-.287-5.064 1.191 1.23-4.938-.316-.507A13.267 13.267 0 012.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.27-9.862c-.398-.199-2.354-1.162-2.719-1.294-.365-.133-.631-.199-.897.199-.266.398-1.03 1.294-1.262 1.56-.232.266-.465.299-.863.1-.398-.199-1.681-.619-3.202-1.976-1.183-1.056-1.982-2.36-2.214-2.758-.232-.398-.025-.613.174-.811.179-.178.398-.465.597-.698.199-.232.266-.398.398-.664.133-.266.066-.498-.033-.697-.1-.199-.897-2.162-1.229-2.96-.324-.777-.653-.672-.897-.684l-.764-.013c-.266 0-.697.1-1.063.498-.365.398-1.394 1.362-1.394 3.322s1.427 3.854 1.626 4.12c.199.266 2.808 4.287 6.802 6.013.951.41 1.693.655 2.271.839.954.304 1.823.261 2.51.158.766-.114 2.354-.962 2.686-1.891.332-.93.332-1.727.232-1.892-.1-.165-.365-.265-.763-.464z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
